import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

let optionsConfigured = false;
const libraryPromises = new Map();

const getApiKey = () => import.meta.env.VITE_GOOGLE_MAPS_API_KEY;

const configureGoogleMaps = () => {
  if (optionsConfigured) return;

  const apiKey = getApiKey();
  if (!apiKey) {
    throw new Error('Google Maps API key is missing.');
  }

  setOptions({ key: apiKey });
  optionsConfigured = true;
};

export const loadGoogleMapsLibrary = (libraryName) => {
  if (!libraryName) {
    return Promise.reject(new Error('Google Maps library name is required.'));
  }

  try {
    configureGoogleMaps();
  } catch (error) {
    return Promise.reject(error);
  }

  if (!libraryPromises.has(libraryName)) {
    const libraryPromise = importLibrary(libraryName).catch((error) => {
      libraryPromises.delete(libraryName);
      console.error(`Failed to load Google Maps ${libraryName} library.`, error);
      throw error;
    });

    libraryPromises.set(libraryName, libraryPromise);
  }

  return libraryPromises.get(libraryName);
};

export const loadGoogleMapsApi = async (libraries = []) => {
  const uniqueLibraries = [...new Set(['maps', ...libraries])];
  const loadedLibraries = await Promise.all(uniqueLibraries.map(loadGoogleMapsLibrary));

  return uniqueLibraries.reduce((acc, libraryName, index) => ({
    ...acc,
    [libraryName]: loadedLibraries[index],
  }), {});
};
